import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, MessageCircle, Star } from "lucide-react";
import { ADDRESS, PHONES, HOURS, WHATSAPP_URL, MAP_EMBED_URL } from "@/lib/site";
import { SEO_NAV } from "@/lib/seo";

export const Footer = () => {
  return (
    <footer id="contact" className="border-t border-white/10 bg-[#08090D]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="font-display text-3xl tracking-[0.12em] text-slate-50">SAGITTARIUS</div>
          <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500">Motor Works</div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">
            Independent car repair & service centre. BMW specialists. Precision in every revolution since 2025.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Workshop</h4>
          <div className="mt-5 flex items-start gap-3 text-sm text-slate-400">
            <MapPin size={16} className="mt-0.5 shrink-0 text-amber-600" />
            <span data-testid="footer-address">{ADDRESS}</span>
          </div>
          {PHONES.map((p) => (
            <a key={p.id} href={p.tel} className="mt-4 flex items-center gap-3 text-sm text-slate-400 transition-colors hover:text-slate-100" data-testid={`footer-phone-${p.id}`}>
              <Phone size={16} className="shrink-0 text-amber-600" /> {p.display}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp"
            className="mt-5 inline-flex items-center gap-2 border border-emerald-500/50 bg-emerald-500/10 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-emerald-400 transition-colors hover:bg-emerald-500 hover:text-black"
          >
            <MessageCircle size={14} /> Chat on WhatsApp
          </a>
          <a
            href="https://search.google.com/local/writereview?placeid=ChIJJ6PwcwzZbW0R0gGO5NVVqqI"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-google-review"
            className="mt-3 inline-flex items-center gap-2 border border-amber-600/50 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-amber-500 transition-colors hover:bg-amber-600 hover:text-black"
          >
            <Star size={14} /> Leave us a Google review
          </a>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Hours</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-3" data-testid="footer-hours"><Clock size={16} className="shrink-0 text-amber-600" /> {HOURS}</li>
            <li className="flex items-center gap-3"><Clock size={16} className="shrink-0 text-red-400" /> Breakdown line · 24/7</li>
          </ul>
          <h4 className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Pages</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-400" data-testid="footer-pages">
            {SEO_NAV.map((l) => (
              <li key={l.to}><Link to={l.to} className="transition-colors hover:text-amber-500">{l.label === "Services" ? "Car Servicing & Repairs" : l.label === "BMW Coding" ? "BMW Coding & Programming" : l.label === "Breakdown" ? "24/7 Breakdown Help" : l.label === "About" ? "About Us" : "Contact & Book"}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Find us</h4>
          <div className="mt-5 overflow-hidden border border-white/10" data-testid="footer-map">
            <iframe
              title="Sagittarius Motor Works location map"
              src={MAP_EMBED_URL}
              width="100%"
              height="220"
              style={{ border: 0, filter: "invert(0.92) hue-rotate(180deg) saturate(0.6)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-6 lg:px-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
            © 2026 Sagittarius Motor Works. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/fleet" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-amber-500" data-testid="footer-fleet-link">
              Customer Login
            </Link>
            <Link to="/admin/login" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600 transition-colors hover:text-amber-500" data-testid="footer-admin-link">
              Staff Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
